import React, { useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import { authAxios } from "../Config/config";
import { toast } from "react-toastify";

const EditInventoryModal = ({ setShowModal, editingOption, formik }) => {
  useEffect(() => {
    if (!editingOption) return;

    const fetchStaffById = async (id) => {
      try {
        const res = await authAxios().get(`/inventory/${id}`);
        const data = res.data?.data || res.data || null;

        if (data) {
          formik.setValues({
            product_name_en: data.product_name_en || "",
            product_name_hi: data.product_name_hi || "",
            total:'1'
          });
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to fetch module details");
      }
    };

    fetchStaffById(editingOption);
  }, [editingOption]);

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        onClick={() => {
          formik.resetForm();
          setShowModal(false);
        }}
      ></div>
      <div className="fixed inset-0 flex justify-center items-start pt-10 pb-5 z-50 overflow-auto w-full max-w-[400px] mx-auto custom--overflow">
        <div className="flex flex-col relative w-[95%] mx-auto">
          <div className="w-full bg-white rounded-[20px]">
            <div className="flex gap-2 items-center justify-between lg:py-3 py-2 lg:px-5 px-3 border-b border-b-[#D4D4D4]">
              <h3 className="text-lg font-semibold">
                {editingOption ? "Add Stock" : "Create Inventory"}
              </h3>
              {/* Close button */}
              <button
                className="text-2xl"
                onClick={() => {
                  formik.resetForm();
                  setShowModal(false);
                }}
                aria-label="Close"
              >
                <IoMdClose />
              </button>
            </div>

            <form onSubmit={formik.handleSubmit}>
              <div className="grid lg:grid-cols-1 grid-cols-1 gap-x-3 lg:gap-y-5 gap-y-4 lg:pb-5 pb-2 lg:pt-5 pt-2 lg:px-5 px-3">
                <div>
                  <label className="mb-2 block font-[500]">
                    Product Name (English)<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="product_name_en"
                    value={formik.values.product_name_en || ""}
                    onChange={formik.handleChange}
                    placeholder="Product Name (English)"
                    className="custom--input w-full"
                    disabled={editingOption ? true : false}
                  />
                  {formik.touched.product_name_en && formik.errors.product_name_en && (
                    <div className="text-red-500 text-sm">
                      {formik.errors.product_name_en}
                    </div>
                  )}
                </div>
                <div>
                  <label className="mb-2 block font-[500]">
                    Product Name (Hindi)<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="product_name_hi"
                    value={formik.values.product_name_hi || ""}
                    onChange={formik.handleChange}
                    placeholder="Product Name (Hindi)"
                    className="custom--input w-full"
                    disabled={editingOption ? true : false}
                  />
                  {formik.touched.product_name_hi && formik.errors.product_name_hi && (
                    <div className="text-red-500 text-sm">
                      {formik.errors.product_name_hi}
                    </div>
                  )}
                </div>
                <div>
                  <label className="mb-2 block font-[500]">
                    Stock<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    name="total"
                    value={formik.values.total || ""}
                    onChange={formik.handleChange}
                    placeholder="Stock"
                    className="custom--input w-full"
                  />
                  {formik.touched.total && formik.errors.total && (
                    <div className="text-red-500 text-sm">
                      {formik.errors.total}
                    </div>
                  )}
                </div>
              </div>
              <div className="flex justify-end gap-3 lg:pb-5 pb-2 lg:px-5 px-3">
                <button
                  type="button"
                  onClick={() => {
                    formik.resetForm();
                    setShowModal(false);
                  }}
                  className="bg-[#EFEFEF] gap-2 h-[38px] flex items-center justify-center cursor-pointer rounded-lg w-full max-w-[120px] text-black"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-[#008421] gap-2 h-[38px] flex items-center justify-center cursor-pointer rounded-lg w-full max-w-[120px] text-white"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditInventoryModal;
